export interface UserHistoryRowDTO {
    action?: string;
    actionPerformedBy?: string;
    actionPerformedDt?: Date;
}
